export enum AutoLoginStep {
  Idle,
  Checking,
  Skipped,
  Success,
  Error,
  LoggedOut,
}
